import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { BaseHttpService } from "@shared/services/base-http.service";

import { NotificationModel } from "../models/notification.model";

@Injectable({ providedIn: "root" })
export class NotificationHttpService extends BaseHttpService {
  protected override baseEndpoint = "notifications";

  findAll(): Observable<NotificationModel[]> {
    return this.get<NotificationModel[]>({ endpoint: "" });
  }

  getUnreadCount(): Observable<{ count: number }> {
    return this.get<{ count: number }>({ endpoint: "unread-count" });
  }

  markAsRead(id: string): Observable<NotificationModel> {
    return this.patch<NotificationModel>({ endpoint: `${id}/read`, body: {} });
  }

  markAllAsRead(): Observable<void> {
    return this.patch<void>({ endpoint: "read-all", body: {} });
  }

  deleteNotification(id: string): Observable<void> {
    return this.delete<void>({ endpoint: `${id}` });
  }
}

